import { css, Interpolation, Theme } from '@emotion/react'

export const checkbox: Interpolation<Theme> = (theme) => css`
  margin-bottom: ${theme.spacing(2)};
`

export const fractionFields: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
